import axiosInstance from '@/store/axios';
import { rejectErrorApi } from '@/store/helper';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    getImports({ commit }, params) {
      return axiosInstance.get('/import/index', {
        params,
      })
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return result.data.ingesters || [];
        })
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    getImportById({ commit }, id) {
      return axiosInstance.get(`/import/data/${id}`)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return result.data.ingester;
        })
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    createMRSSImport({ dispatch }, data) {
      return axiosInstance.post('/import/mrss/create', data)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return result.data;
        })
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    updateMRSSImport({ dispatch }, data) {
      return axiosInstance.post('/import/mrss/update', data)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return result.data;
        })
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    removeImport({ dispatch }, id) {
      return axiosInstance.get(`/import/remove/${id}`)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return result.data;
        })
        .catch((error) => Promise.reject(error));
    },
    // eslint-disable-next-line no-unused-vars
    parseMRSS({ dispatch }, data) {
      // mrss_url
      return axiosInstance.post('/import/mrss/mapper/parse', data)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApi(result);
          }
          return result.data;
        })
        .catch((error) => Promise.reject(error));
    },
  },
};
